import axios from 'axios';
import { Auth } from 'aws-amplify';
import { logoutSessionAD } from './sessionAD.helper';
//constantes
const headers = {
    'Content-Type': 'application/json',
    Authorization: ''
};
const getToken = async(verifySession) => {
    if(verifySession) {
        await Auth.currentSession()
        .then(data => {
            //console.log('get current session token in services');
            headers.Authorization = data.idToken.jwtToken;
        })
        .catch((error) => {
          console.log(error);
          logoutSessionAD();
        });
    } else { headers.Authorization = (await Auth.currentSession()).accessToken.jwtToken; }    
}
// eslint-disable-next-line no-unused-vars
export  function getService(url) {
    return new Promise((resolve, reject) => {
        (async () => {
            await getToken(true);
        
            axios
                .get(url, {
                    headers: headers,
                    method: 'get'
                }).then(res => {
                    resolve(res);
                }).catch(error => {
                    resolve(error);
                });
        })().catch(reject);
    });

}
export const postService = (url, body) => {
    return new Promise((resolve, reject) => {
        (async () => {
            await getToken(true);
            axios({
                method: 'post',
                url: url,
                data: body,
                headers: headers
            }).then(res => {
                resolve(res);
            }).catch(error => {
                console.warn('error', error)
            });
        })().catch(reject);
    })
}

export const postBodyService = (url, json) => {
    return new Promise((resolve, reject) => {
        (async () => {
            await getToken(true);
            axios({
                method: 'post',
                url: url,
                data: JSON.stringify(json),
                mode: 'no-cors',
                crossDomain: true,
                headers: headers
            }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log("post error", error)
                resolve(error);
            });
        })().catch(reject);
    });
}
export const sendRequest = (url, json,metod) => {
    return new Promise((resolve, reject) => {
        (async () => {
            await getToken(true);
            axios({
                method: metod,
                url: url,
                data: JSON.stringify(json),
                mode: 'no-cors',
                crossDomain: true,
                headers: headers
            }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log("post error", error)
                resolve(error);
            });
        })().catch(reject);
    });
}